<style lang="scss" scoped>
.reports {
	&__header {
		@include flex-center;
		h3 {
			margin: 0;
			padding: 0 !important;
		}
		&__key {
			display: flex;
			margin-left: auto;
		}
	}
	&__content {
		margin-top: 35px;
	}
	h3 {
		padding-bottom: 20px;
	}
	ul {
		display: flex;
		flex-wrap: wrap;
		padding: 0;
		list-style: none;
		li {
			margin: 0;
		}
	}
	&__indicator {
		border-radius: 3px;
		text-align: center;
		line-height: 33px;
		color: white;
		margin-right: 6px;
		&__tile {
			width: 30px;
			height: 30px;
			margin-bottom: 6px;
		}
		&__key {
			padding-right: 10px;
			padding-left: 10px;
		}
	}
	.status--queued {
		background: #d3d3d3;
		color: #5b5b5b;
	}
	.status--running {
		background: #4ca8ee;
	}
	.status--accepted {
		background: #7664e5;
	}
	.status--failing {
		background: #ff7700;
	}
	.status--failed {
		background: #da3b3d;
	}
	.status--finished {
		background: #327e07;
	}
	.status--deleted {
		background: #790b00;
	}
	.status--exception {
		background: #000;
	}
	.no-reports {
		margin-top: 50px;
		text-align: center;
	}
}
</style>

<template lang="pug">
	el-card.reports(v-loading="$apollo.loading")
		.reports__header
			h3 Report Punchcard 
			.reports__header__key
				el-tooltip.item(effect='dark' content='Report is waiting in queue' placement='bottom')
					.reports__indicator.reports__indicator__key.status--queued Queued
				el-tooltip.item(effect='dark' content='Report is being processed' placement='bottom')
					.reports__indicator.reports__indicator__key.status--accepted Accepted
				el-tooltip.item(effect='dark' content='Report is currently running' placement='bottom')
					.reports__indicator.reports__indicator__key.status--running Running
				el-tooltip.item(effect='dark' content='Report is currently failing' placement='bottom')
					.reports__indicator.reports__indicator__key.status--failing Failing
				el-tooltip.item(effect='dark' content='Report has failed' placement='bottom')
					.reports__indicator.reports__indicator__key.status--failed Failed
				el-tooltip.item(effect='dark' content='Report finished successfully' placement='bottom')
					.reports__indicator.reports__indicator__key.status--finished Finished
				el-tooltip.item(effect='dark' content='Report errored and failed' placement='bottom')
					.reports__indicator.reports__indicator__key.status--exception Error
				//- .reports__indicator.reports__indicator__key.status--deleted Deleted
		.reports__content
			el-row(:gutter='30', v-if="reports.length")
				el-col(v-if="groupedReports && Object.keys(groupedReports).length")
					.reports__content__type(v-for="(reportType, type) in groupedReports" :key="reportType.id")
						h4 {{ type.split("_").join(" ") }}
						ul
							li(v-for="report in sortLatest(groupedReports[type])" :key="report.id" @click="viewReport(report)")
								el-tooltip.item(effect='dark', :content="hoverInfo(report)", placement='bottom')
									.reports__indicator.reports__indicator__tile(:class="`status--${report.status}`") {{ indicator(report) }}
			empty(v-else, :side-margin="false") No reports have run at this school recently
</template>

<script>
import gql from "graphql-tag";
import { groupBy, sortBy } from "lodash";
import ReportInfo from "./ReportInfoModal";

export default {
	name: "SchoolReportPunchard",
	props: ["school"],
	components: {
		ReportInfo
	},

	created() {
		this.$bus.on("reports-fired", () => {
			this.$apollo.queries.reports.refresh();
		});
	},

	data: () => {
		return {
			reports: []
		};
	},

	computed: {
		groupedReports: function() {
			return groupBy(this.reports, "report_name");
		}
	},

	methods: {
		viewReport(report) {
			this.$vuedals.open({
				component: ReportInfo,
				title: `Report #${report.id}`,
				props: {
					report: report
				}
			});
		},
		indicator(report) {
			switch (report.status) {
				case "queued":
					return "Q";
				case "accepted":
					return "A";
				default:
					return report.attempts;
			}
		},
		sortLatest(reports) {
			if (!reports || !reports.length) {
				return [];
			}
			return sortBy(reports, function(report) {
				return new Date(report.run_at);
			}).reverse();
		},
		hoverInfo: function(report) {
			return `${report.attempts} attempts, ${this.$options.filters.standard_datetime(report.run_at)}`;
		}
	},

	apollo: {
		reports: {
			query: gql`
				query ReportPunchards($school_id: ID) {
					ReportPunchards(school_id: $school_id) {
						id
						run_at
						status
						report_name
						created_at
						attempts
						query_time
						query_count
						error
						permitted
					}
				}
			`,
			update(r) {
				return r.ReportPunchards;
			},
			variables() {
				return {
					school_id: this.$route.params.school
				};
			},
			pollInterval: 10 * 1000
		}
	}
};
</script>
